/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_Feature_4Inputs */

const et_plan_visibility_feature_4 = /** @type {(inputs: Plan_Visibility_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aitame sul nähtav olla nii Google's kui ka AI-otsingutes`)
};

const en_plan_visibility_feature_4 = /** @type {(inputs: Plan_Visibility_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We help you stay visible on Google and in AI search`)
};

/**
* | output |
* | --- |
* | "We help you stay visible on Google and in AI search" |
*
* @param {Plan_Visibility_Feature_4Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_feature_4 = /** @type {((inputs?: Plan_Visibility_Feature_4Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_Feature_4Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_feature_4(inputs)
	return en_plan_visibility_feature_4(inputs)
});